import installSnackbarPlugin from '@hokify/shared-components-nuxt3/lib/plugins/snackbar';

export default defineNuxtPlugin({
	name: 'snackbar',
	setup(nuxtApp) {
		installSnackbarPlugin(nuxtApp);
	}
});
